export const BADGE_ACTION_START = 'BADGE_ACTION_START';
export const BADGE_ACTION_ERROR = 'BADGE_ACTION_ERROR';
export const GET_ALL_BADGES = 'GET_ALL_BADGES';
export const GET_BADGE = 'GET_BADGE';
export const CREATE_BADGE = 'CREATE_BADGE';
export const UPDATE_BADGE = 'UPDATE_BADGE';
export const DELETE_BADGE = 'DELETE_BADGE';

export const badgeActionStart = () => ({ type: BADGE_ACTION_START });
export const badgeActionError = (error: any) => ({ type: BADGE_ACTION_ERROR, payload: error });
export const getAllBadgesAction = (badges: any[]) => ({ type: GET_ALL_BADGES, payload: badges });
export const getBadgeAction = (badge: any) => ({ type: GET_BADGE, payload: badge });
export const createBadgeAction = (badge: any) => ({ type: CREATE_BADGE, payload: badge });
export const updateBadgeAction = (badge: any) => ({ type: UPDATE_BADGE, payload: badge });
export const deleteBadgeAction = (id: string) => ({ type: DELETE_BADGE, payload: id }); 